<template>
	<div data-v-steps="2">
		<div v-show="smScrennFull" class="small-screenfull">
			<el-drawer style="z-index: 20000;" title="我是标题" :visible.sync="openDrawer" :with-header="false"
				:direction='openDirection' size='240px' :modal-append-to-body="modal">
				<div class="nav">
					<div class="page_navtitle">
						<span class="logoimg"></span>
						<div class="tisp-trial">体验版</div>
						<div class="fl">
							<span class="navtitle_city fwb text-left pl-3">中投顾问</span>
							<span class="navtitle_web fwb">产业研究大脑</span>
							
						</div>
					</div>
					<div class="oh flexcss left-nav-version-title" v-show="curWebsite.type == 1 || curWebsite.type == 7 || curWebsite.type == 8|| curWebsite.type == 9">
						<span :class="['title',zsdn_version == 1 ?'current':'', ]" @click="zsdnVersionToggle(1)">易用版<i class="el-icon el-icon-check" v-show="zsdn_version == 1"></i></span>
						<span :class="['title',zsdn_version == 2 ?'current':'', ]" @click="zsdnVersionToggle(2)">专业版<i class="el-icon el-icon-check" v-show="zsdn_version == 2"></i></span>
					</div>
					<dl :class="['menu_block',{'current':mkcode==list.code},{'dn':editionBlock.indexOf(list.code)>0&&edition<1}]"
						:key="index" v-for="(list,index) in localRouter" v-show="list.switch">
						<dt class="dt_nav">
							<span @click="navClickLink(list)"><i :class="list.icontype"></i>{{list.oldtext}}</span>
							<span :title="list.open?'展开':'收起'" v-if="list.openicon" @click="list.open=!list.open"><i
									:class="list.open?'el-icon-arrow-up':'el-icon-arrow-down'"
									style="margin-left: 20px"></i></span>
						</dt>
						<dd v-show="list.open"> 
							<span
								:class="['nav_li',{'li-current':itemcode==item.code},{'db':item.oldtext.length>6},{'red-icon':item.newType}]"
								:key="eq" :data="item.newType" v-for="(item,eq) in list.children"
								@click="navClickLink(item)" v-show="item.switch">{{item.oldtext}}</span>
							<span v-show="list.morebtn" @click="showMoreNav(list)">更多功能<i class="el-icon-arrow-down"
									style="margin-left:3px"></i></span>
						</dd>
					</dl>
				</div>
			</el-drawer>
			<span class="screen" @click="openDrawer = true" style="z-index: 1999;"><i
					class="el-icon-s-unfold"></i>菜单栏</span>
		</div>
		<div v-show="!smScrennFull" class="common-screenfull" id="testbox">
			<div class="nav" ref="leftMenu" :style="isCollapse?'width: 0px;':''">
				<span class="meunm-close-btn"  title="关闭菜单" @click="onClickfoldBtn"><i class="el-icon-close"></i></span>
				<div class="page_navtitle">
						<img src="@/assets/images/zt_logo_sm.png" alt="" class="logo-img">
						<div class="tisp-trial">体验版</div>
						<div class="fl">
							<span class="navtitle_city fwb text-left pl-3">中投顾问</span>
							<span class="navtitle_web fwb" >产业研究大脑</span>
						</div>
					</div>
				<!-- <div class="oh flexcss left-nav-version-title" v-show="curWebsite.type == 1 || curWebsite.type == 7 || curWebsite.type == 8|| curWebsite.type == 9">
					<span :class="['title',zsdn_version == 1 ?'current':'', ]" @click="zsdnVersionToggle(1)">易用版<i class="el-icon el-icon-check" v-show="zsdn_version == 1"></i></span>
					<span :class="['title',zsdn_version == 2 ?'current':'', ]" @click="zsdnVersionToggle(2)">专业版<i class="el-icon el-icon-check" v-show="zsdn_version == 2"></i></span>
				</div> -->
				<dl :class="['menu_block',{'current':mkcode==list.code},{'dn':editionBlock.indexOf(list.code)>0&&edition<1}]"
					:key="index" v-for="(list,index) in localRouter" v-show="list.switch">
					<dt class="dt_nav">
						<span @click="navClickLink(list,index,'dt')" :class="mktype == list.type? 'darkred': ''"><i :class="list.icontype"></i>{{list.oldtext}}</span>
						<span :title="list.open?'展开':'收起'" v-if="list.openicon" @click="list.open=!list.open"><i
								:class="list.open?'el-icon-arrow-up':'el-icon-arrow-down'"
								style="margin-left: 20px"></i></span>
					</dt>
					<dd v-show="list.open">
						<!--  -->
						<span
							:class="['nav_li',{'li-current':itemcode==item.code},{'db':item.oldtext.length>6 }, {'red-icon':item.newType} ]"
							:data="item.newType" :key="eq" v-for="(item,eq) in list.children"
							@click="navClickLink(item,eq,'dd')" v-show="item.switch">{{item.oldtext}}</span>
						<span v-show="list.morebtn" @click="showMoreNav(list)">更多功能<i class="el-icon-arrow-down"
								style="margin-left:3px"></i></span>
					</dd>
				</dl>
			</div>
		</div>
		 
	</div>
</template>
<script>
	import screenfull from 'screenfull'
	// import $ from "jquery" 
	import ajaxapi from "@/utils/api.js"
	import messgeAlertPop from "@/components/inc/messge-alert-pop"
	import { mapState, mapMutations, mapGetters } from "vuex";
	import {localRouter_meun_yj} from './utils/localRouter_meun_yj.js';
	import {localRouter_meun_zs} from './utils/localRouter_meun_zs.js';
	import {localRouter_meun_tz} from './utils/localRouter_meun_tz.js';
	import {localRouter_meun_zl} from './utils/localRouter_meun_zl.js';
	import {localRouter_meun_yq} from './utils/localRouter_meun_yq.js';
	import {localRouter_meun_xd} from './utils/localRouter_meun_xd.js';
	import {localRouter_meun_zs_simple} from './utils/localRouter_meun_zs_simple.js';
	import {localRouter_meun_free} from './utils/localRouter_meun_free.js';
	 
	export default {
		name: 'leftNav', 
		computed: {
		...mapState({
		isMsgAlert: (state) => state.isMsgAlert,
		isCollapse: (state) => state.isCollapse,
		isSmsLogin: (state) => state.isSmsLogin,
		}),
		...mapGetters(['isCollapse','isMsgAlert','isSmsLogin'])
		},
		data() {
			return {
				logoimg:'',
				zsdn_version: 1, //产业招商大脑type=1 || type=7时使用 1为简易版 2为专业版
				enabled: false,
				steps: [{
						target: '#testbox', // 需要引导的目标元素的 CSS 选择器
						content: '这是第一步引导', // 引导内容
						placement: 'top' // 引导页对齐方式 
					},
					{
						target: '.search-box',
						content: '这是第二步引导'
					}
				],
				leftNavTitle: "", //
				mkcode: "",
				curWebsite: this.$api.getWebsiteType(),
				autoOperate: true,
				isFullscreen: false,
				openDrawer: false,
				modal: false,
				openDirection: "ltr", //btt
				openDirection2: "btt", //btt
				edition: 0, //0为普通版 1为专业版 &cyyj&datu
				groupType: 0, //0为试用账户 1为正式账户 &cyyj&datu
				editionBlock: "", //普通版就会被隐藏的板块
				islogin: false,
				userdata: {},
				menucurType: 0,
				menucurLi: 0,
				zhengshipage: "全国图谱-产业链详情页，当地图谱-目标企业-概念下当地企业详情，产业园区库-园区详情页 招商情报- 招商情报详情页 产业政策-政策详情页 城市监测里的图",
				nums: 1,
				localRouter: [],
				cyzsMoreshow: "&科研机构&招商地图&研发机构&协会商会&专业镇", //工作台里的&统计分析&项目管理&跟进记录&待办记录 已经加上大板块的收缩隐藏了
				localRouter_zs_simple: localRouter_meun_zs_simple,
				localRouter_zs:localRouter_meun_zs,
				localRouter_zl: localRouter_meun_zl,
				localRouter_xd: localRouter_meun_xd,
				localRouter_yq: localRouter_meun_yq,
				//战略投资大脑 导航栏顺序
				localRouter_tz: localRouter_meun_tz,
				//产业研究大脑 
				localRouter_yj: localRouter_meun_yj,
				//研究大脑调出来免费不用登陆版
				localRouter_free:localRouter_meun_free,
			}
		},
		props: {
			msg: String,
			curindex: {
				required: false,
				default: '',
			},
			openmeun: Boolean,
			smScrennFull: {
				required: false,
				default: false,
			},
			haspagetitle: {
				required: false,
				default: false,
			},
			// 新的参数
		 
			mkopen: {
				required: false,
				default: true,
			},
			mktype:{
				required: false,
				default: '',
			},
			itemcode: String,
			docutitle: {
				required: false,
				default: '',
			},
		},
		components: {
			messgeAlertPop
		},
		watch: {
			itemcode: {
				handler(newValue, oldValue) {
					this.type = newValue;
					this.toogleBlockOpen(); //用于下拉框是否展示

				}
			},
		},
		created() {
			// this.getuserinfor();
			 
		},
		mounted() { 
			this.turnUserMenu() ;
			// this.toogleBlockOpen();   
			// if((this.curWebsite.type == 1 || this.curWebsite.type == 9 || this.curWebsite.type == 8 || this.curWebsite.type == 4 || this.curWebsite.type == 6) && this.userdata.groupType == 0 && !this.userdata.autoOperate){	
			// 	console.log('自动操作');
			// 	this.testUserAutoOperationNew();
			// } 
			
		},
		methods: {
			...mapMutations({
				set_collapse: "SET_COLLAPSE",
			}),
			//折叠菜单
			onClickfoldBtn() {
				console.log('点击展开收起',this.isCollapse)
				this.set_collapse(!this.isCollapse);
			},
			//判断试用用户登录次数自动弹框 
			//如果当前用户为研究大脑、信贷大脑的试用账户且刚刚登陆 则自动打开使用指引弹框
			// this.userdata.groupType=0;
			//招商大脑试用账户只在第一次登录时展开,易用正式的试用指引或者第一次切换正式版时展开全部试用指引
			testUserAutoOperationNew(){ 
				this.userdata.autoOperate = true;
				var	operatDemoType="total"; 
				if((this.curWebsite.type == 1 || this.curWebsite.type == 8|| this.curWebsite.type == 9) && this.userdata.loginNum == 1){ 
					this.userdata.autoOperate = false;
					operatDemoType="zsdn_version";
					this.userdata.loginNum=this.userdata.loginNum+1;
				} 
				var datasm1 = JSON.stringify(this.userdata);
				localStorage.setItem('userData', datasm1);
				sessionStorage.setItem('userData', datasm1);  
				console.log(operatDemoType,3)
				this.bus.$emit('operatDemo', true,operatDemoType);

				// this.bus.$emit('operatDemo',true,operatDemoType);
			},
			//招商大脑简易版和专业版切换
			zsdnVersionToggle(type) { 
				if(this.zsdn_version == type){
					return;
				}
				this.zsdn_version = type;
				this.userdata.zsdn_version = type;
				this.userdata.zsdn_version_num=this.userdata.zsdn_version_num+1;
				var datasm1 = JSON.stringify(this.userdata);
				localStorage.setItem('userData', datasm1);
				sessionStorage.setItem('userData', datasm1);
				if(type == 1){
					this.routerself('/invest-project-trend?type=3');
				}else {
					this.routerself('/totalEnterprises');
				} 
			},
			getTitleFontSize(title) { //12.5提出字数太大要改变字体大小后又觉得不需要改变
				let font = 'fontSize:20px';
				// if(title.length<=7){
				// 	font = "fontSize:20px";
				// }else{
				// 	font = "fontSize:"+(18-(title.length-7))*1+'px';
				// } 
				return font;
			},
			showMoreNav(list) { //点击更多功能时将list.morebtn转为false,并将所有的子集元素switch改为true
				list.morebtn = false;
				var listch = list.children;
				for (var d = 0; d < listch.length; d++) {
					list.children[d].switch = true;
				}
				// console.log(list)
			},
			//将不能被显示的链接进行隐藏判断
			navHiddenInfor(list) {
				//先把所有不显示的信息栏剔除 
				// for (var i = 0; i < list.length; i++) {
				// 	var listch = list[i].children;
				// 	var listnew = listch.filter(dd => {
				// 		return dd.switch;
				// 	});
				// 	list[i].children = listnew;
				// }
				// //循环判断该模块是否有个更多按钮 有就需要在这里面进行将switch变更false，morebtn也变为true,
				// for (var i = 0; i < list.length; i++) {
				// 	var listch = list[i].children;
				// 	for (var d = 0; d < listch.length; d++) {
				// 		let tabname = listch[d].oldtext; //用oldtext是因为有些文字是由前台写死的 后台还没加上 后期统一更新后即可改为name
				// 		if (this.cyzsMoreshow.indexOf(tabname) > 0) {
				// 			list[i].morebtn = true;
				// 			// list[i].children[d].oldtext=listch[d].oldtext+'d';
				// 			list[i].children[d].switch = false;
				// 		}
				// 	}
				// }
				// //研究大脑 直辖城市 隐藏本省产业链
				// // if(this.curWebsite.type == 6){
				// // 	var curcity=this.userdata.currentCity.text;
				// // 		let zhixia="&北京市天津市上海市重庆市";
				// // 		if(this.userdata.isZhixia){
				// // 		webmenu.forEach(list=>{
				// // 			if(list.code == 'L'){
				// // 				list.children.forEach(item=>{
				// // 					if(item.oldtext=='本省产业链'){
				// // 						item.switch=false;
				// // 					}
				// // 				})
				// // 			}
				// // 		})
				// // 	}
				// // }
				
				
				// this.localRouter = list;
			},
			//当前页面高标亮显示 
			toogleBlockOpen() {
				var title = '';
				for (var i = 0; i < this.localRouter.length; i++) { 
					for (var d = 0; d < this.localRouter[i].children.length; d++) {
							this.localRouter[i].open = this.mkopen;
							this.mkcode=this.localRouter[i].code;
						if (this.localRouter[i].children[d].code == this.itemcode) {
							title = this.localRouter[i].children[d].oldtext;
							if (!this.localRouter[i].children[d].switch) {
								this.localRouter[i].morebtn = false;
								this.localRouter[i].children.forEach(dd => {
									dd.switch = true;
								})
							} 
						}
					}
				}
				console.log('当前页面高标亮显示',title);
				title = this.docutitle == "" ? title : this.docutitle; //优先拿页面设置的，如果是菜单里有的，页面就不需要设置了 这是为了给那些菜单里没有又想要高标亮显示的页面设置的
				document.title = title +'-产业研究大脑体验版';
			},
			//将后台传过来的menu和本地的menuurl结合
			turnUserMenu() {
				var setmenu = this.userdata.menu;
				var webmenu = [];
					webmenu = this.localRouter_free; 
				// this.userdata.province=36;
				//本地投资趋势仅限于招商大脑 用户注册地为江西36、安徽34使用
				if(this.userdata.province == 36 || this.userdata.province == 34 || this.userdata.province == 44){ 
					for(var i=0;i<webmenu.length;i++){
						if(webmenu[i].oldtext == '本地投资趋势'){
							webmenu[i].switch=true;
						}
					}  
				}
				//2024.4.28 设置了只能手机号验证码登陆的隐藏修改密码
				if(this.isSmsLogin){
						for(var i=0;i<webmenu.length;i++){
						for(var d=0;d<webmenu[i].children.length;d++){
							if(webmenu[i].children[d].oldtext == '密码修改'){
								webmenu[i].children[d].switch=false;
							}
						}
					}
				}
				//20240422 招商办渠道用户隐藏服务手册
				if(this.curWebsite.type == 8){
					console.log('服务手册',webmenu);
					for(var i=0;i<webmenu.length;i++){
						for(var d=0;d<webmenu[i].children.length;d++){
							if(webmenu[i].children[d].oldtext == '服务手册'){
								webmenu[i].children[d].switch=false;
							}
						}
					}
				}
				 
					this.localRouter = webmenu;
    
				console.log('webmenu',webmenu)
			},
			//新的跳转链接
			navClickLink(item,index,type) {
				var url = item.url;
				if (url == 'loginout') {
					this.logout()
				} else if (url == 'report') {
					window.open(ajaxapi.getReportUrl() + '&token=' + this.userdata.token); //研究报告库外部跳转
				} else if (url == 'reportList') {
					window.open(ajaxapi.getReportListUrl(item.reportId) + '&token=' + this.userdata.token); //研究报告库外部跳转
				} else if (url == "land" || url == 'invest') {  
					// window.open(ajaxapi.getBigDataUrl(url) + '&token=' + this.userdata.token+areaInfor); // 外部跳转拿地信息库 投资项目库跳转
					this.$axios.get(this.$api.enterpriseapi.land.url() ,{
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {  
						window.open(res.data.data[url]);
						// that.listUrl=res.data.data.invest; 
					})  
				} else if (url == 'freeReport') { //跳转到免费报告库
					window.open(ajaxapi.getFreeReportUrl(item.reportId));
				} else {
					// this.nums++;
					// if (url.indexOf('enterpriseList') > 0) {
					// 	if (url.indexOf('?') < 0) {
					// 		url = url + '?t=' + this.nums;
					// 	} else {
					// 		url = url + '&t=' + this.nums;
					// 	}
					// }
					
					this.routerself(url);
					// let menuList  = '';
					// if(type == 'dt'){
					// 	menuList  = document.getElementByClassName('dt_nav');
					// }else if(type == 'dd'){
					// 	menuList  = document.getElementByClassName('li-current');
					// }
					// let elements = menuList[0];
					// console.log(menuList,elements);
					// elements.scrollIntoView({
					// 	block: 'center', // 值有start,center,end，nearest，当前显示在视图区域中间
					// 	behavior: 'smooth', // 值有auto、instant,smooth，缓动动画（当前是慢速的）
					// });
					}

			},
			screen() {
				if (!screenfull.enabled) { // 如果不允许进入全屏，发出不允许提示
					this.$message({
						message: '不支持全屏',
						type: 'warning'
					})
					return false
				}
				screenfull.toggle(document.getElementById('full-screen'));
				// this.$message({
				//     message: '已开启全屏',
				//     type: 'success'
				//   })
			},
			getuserinfor() {
				
				let dataddd = localStorage.getItem('userData') ? localStorage.getItem('userData') : sessionStorage
					.getItem('userData');
				if (typeof(dataddd) == 'object') {
					this.userdata = dataddd;
				} else {
					this.userdata = JSON.parse(dataddd);
				}
				// this.usernotionlistsave=this.taglistfun(this.userdata.notionText,this.userdata.notion); 
				this.islogin = this.userdata.datetime != undefined; 
				var nowdate = new Date().getMonth() + 1 + '-' + new Date().getDate();
				var logintime = this.userdata.datetime;
				// 正式环境清除所有console.log
				var logbtn = process.env.NODE_ENV === 'production';
				if (process.env.NODE_ENV === 'production' && !this.userdata.log) {
					if (window) {
						window.console.log = function() {};
					}
				}
				console.log(nowdate, logintime, this.userdata);
				if (logintime != nowdate || !this.islogin) {
					this.logout();
				};
				this.zsdn_version = this.userdata.zsdn_version;
				this.groupType = this.userdata.groupType; //区分正式或者试用账户（版本一樣 只是試用時間不一樣）
				this.edition = this.userdata.edition; //區分普通版和正式版  
			},
		},
	}
</script>

<style>
	@import url("../../css/leftnav.css");
	.logo-img{
		 width: 50px;height: 50px;float: left;
	}
	.sima_css{
		color: blueviolet !important;
	}
</style>